export const sizes = {
  sm: 'py-1.5 px-2 text-xs font-semibold',
  md: 'py-[7px] px-3 text-sm font-semibold',
  lg: 'py-2.5 px-3 text-sm font-semibold',
};
